import styled from "styled-components";

export const FormRow = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
    margin-bottom: 4px;
`;